import React from 'react'
import {Context as AppContext} from '../../contexts/App'

import Button from '@mui/material/Button';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography';

const ClientSelection = ({open, close, ...rest}) => {
  const app = React.useContext(AppContext)
  const { clients } = app.clients
  const { selectedProducts, setSelectedProducts, assignClient } = app.products

  const title = selectedProducts?`Asignar cliente a ${selectedProducts.length} producto${selectedProducts.length>1?'s':''}`:''
  return (
    <Dialog onClose={() => setSelectedProducts(false)} open={open}>
      <DialogTitle>{title}</DialogTitle>
      <List sx={{ pt: 0 }}>
        {clients.map((client) => (
          <ListItem button onClick={() => {close();assignClient(client.id);}} key={client.name}>
            <ListItemText primary={client.name} />
          </ListItem>
        ))}
      </List>
    </Dialog>
  )
}
export default ClientSelection